











































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import Images from '../Images.vue'
import { Dress, generateEmptyDress } from '../../types/dresses'
import { Color, Style } from '../../types/constants'
import { DocumentData } from '../../types/images'
import { uploadDocument } from '../../utils/http-client/documents-api'
import { addDress, editDress } from '../../utils/http-client/dress-api'
import { getColors, getStyles } from '../../utils/http-client/constants'
import MessageBus from '../../utils/buses/MessageBus'
import { requiredValidation } from '@/utils/validations'

@Component({
  components: {
    Images
  }
})
export default class DressForm extends Vue {
  @Prop({ default: generateEmptyDress })
  originalDress!: Dress

  @Prop({ default: false })
  isEditing!: Boolean

  private dress: Dress = this.originalDress
  private images: Blob[] = []
  private imagesPreview: string[] = []
  private documents: Blob[] = []
  private documentsPreview: string[] = []
  private colors: Object[] = []
  private styles: Object[] = []
  private valid: boolean = true
  private isSubmitting: boolean = false
  private rules: Object = {
    required: requiredValidation
  }

  async mounted () {
    this.$set(this.dress, 'designer', this.$route.params.id)
    let rawColors: Color[] = await getColors()
    this.colors = rawColors.map(i => {
      return {
        id: i.id,
        text: i.color
      }
    })
    let rawStyles: Style[] = await getStyles()
    this.styles = rawStyles.map(i => {
      return {
        id: i.id,
        text: i.style
      }
    })
  }
  previewImage () {
    this.imagesPreview = []
    this.images.forEach(i => {
      const reader = new FileReader()
      reader.onload = () => {
        this.imagesPreview.push(reader.result as string)
      }
      reader.readAsDataURL(i)
    })
  }
  previewDocument () {
    this.documentsPreview = []
    this.documents.forEach(i => {
      const reader = new FileReader()
      reader.onload = () => {
        this.documentsPreview.push(reader.result as string)
      }
      reader.readAsDataURL(i)
    })
  }
  orderImages (orderedImages: string[]) {
    this.$set(this.dress, 'imageurls', orderedImages)
  }
  orderDocuments (orderedDocuments: string[]) {
    this.$set(this.dress, 'documenturls', orderedDocuments)
  }
  async uploadImages () {
    const promises = this.images.map(image => {
      let isLastImage = image === this.images[this.images.length - 1]
      return uploadDocument(image as any, this.images.length, isLastImage, 'image')
    })
    let newImageurls = await Promise.all(promises)
    newImageurls.forEach(image => {
      if (image) {
        this.dress!.imageurls.push(image)
      }
    })
  }
  async uploadDocuments () {
    const promises = this.documents.map(document => {
      let isLastDocument = document === this.documents[this.documents.length - 1]
      return uploadDocument(document as any, this.documents.length, isLastDocument, 'document')
    })
    let newDocumenturls = await Promise.all(promises)
    newDocumenturls.forEach(document => {
      if (document) {
        this.dress!.documenturls.push(document)
      }
    })
  }
  async deleteImage (index: number) {
    this.dress!.imageurls.splice(index, 1)
  }
  async deleteDocument (index: number) {
    this.dress!.documenturls.splice(index, 1)
  }
  async onSubmit () {
    this.isSubmitting = true
    try {
      // add images
      await this.uploadImages()
      await this.uploadDocuments()

      if (this.isEditing) {
        await editDress(this.dress!)
      } else {
        // add dress
        await addDress(this.dress!)
      }

      this.$emit('close-dialog')
      this.$emit('reload-data', true)
    } catch (err) {
      console.error('Submit Dress Error:', err)
      MessageBus.sendDefaultError()
    } finally {
      this.isSubmitting = false
      this.$emit('close-dialog')
      this.dress = generateEmptyDress()
    }
  }
  private closeForm () {
    this.$emit('close-dialog')
    this.dress = this.originalDress
  }
}
